module.exports = __webpack_public_path__ + "static/media/translation.466cb838.jpg";